// extracted by mini-css-extract-plugin
export default {"svgRoot":"CE75uz","svgButton":"BnL5i_"};